import React, { useEffect, useState } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from '../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextAreaComponents from '../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import plusIcon from './../../../../../assets/icons/plus.png'
import AddItemDialogComponent from '../../AddItemDialog.tsx';

function AddSubscriptionItemDialog(props) {

    //dialog start
    const [openItemDialog, setOpenItemDialog] = useState(false)

    const handleDialogOpen = (name) => {
        if (name == 'item') {
            setOpenItemDialog(true)
        }
    }
    const handleAddItem = (data) => {
        setOpenItemDialog(data)
    }


    //dialog end

    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const sectionDatas = [
        { id: 1, title: 'Item x' },
        { id: 2, title: 'Item y' },
        { id: 3, title: 'Item z' },
        { id: 4, title: 'Item A' },
        { id: 5, title: 'No More Item' },
    ]
    const addOnDatas = [
        { id: 1, title: 'addon x' },
        { id: 2, title: 'addon y' },
        { id: 3, title: 'addon z' },
        { id: 4, title: 'addon A' },
    ]
    const [Item, setItem] = React.useState("");
    const addValue = (props) => {
        console.log(props)
        setItem(props)
    }

    const saveData = () => {
        const values = {
            ItemName: Item,
            addonsItem: addons
        }
        props.onHandleAddItem(values)
    }
    const textFieldValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const [quantity, setquantity] = React.useState(0);

    const [addons, setAddons] = React.useState([]);

    const addaddons = (props) => {
        console.log(props)

        setAddons(props)
    }

    //start
    const [switchComboCheck, setswitchComboCheck] = useState(false)
    const [itemNeedToBuy, setitemNeedToBuy] = useState([]);
    const [tempitemNeedToBuy, settempitemNeedToBuy] = useState([]);
    const [nullvalue, setnullvalue] = useState([]);
    const handleAddEvent = () => {

        if (addons != undefined || addons.length > 0) {

            settempitemNeedToBuy(itemNeedToBuy);
            for (let i = 0; i < addons.length; i++) {
                var d = tempitemNeedToBuy.find(x => x.title === addons[i].title);
                if (d === undefined) {
                    tempitemNeedToBuy.push(addons[i])
                }

            }
            console.log("temData: " + tempitemNeedToBuy);
            // temData = typeNeedToBuyValue;
            setitemNeedToBuy([]);
            setAddons([]);
            setnullvalue([]);
            console.log("itemNeedToBuy: " + itemNeedToBuy);

        }
    }
    useEffect(() => {
        setitemNeedToBuy(tempitemNeedToBuy);
    }, [itemNeedToBuy])

    const handleRemove = (props) => {
        console.log("props: " + props);

        settempitemNeedToBuy(itemNeedToBuy);
        var temp = itemNeedToBuy;
        var obj = temp.find(x => x.id === props);
        var index = temp.indexOf(obj);
        var j = temp.splice(index, 1);
        settempitemNeedToBuy(temp);
        setitemNeedToBuy([]);

        console.log("tempitemNeedToBuy: " + tempitemNeedToBuy);
        console.log("itemNeedToBuy: " + itemNeedToBuy);
    }

    //end


    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Add Item in subscription</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container >
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item Name
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Item Name"}
                                    placeholder={'Item Name'}
                                    value={addValue}
                                    datas={sectionDatas}
                                    id={1}
                                />

                            </Grid>
                            <Grid item xs={2} className="" onClick={() => handleDialogOpen('item')} >
                                {/* <img src={plusIcon} alt="+" /> */}
                                <button className='modalAddButton'>+Add Item</button>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Addons
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Addons"}
                                    placeholder={'Addons'}
                                    value={addaddons}
                                    datas={addOnDatas}
                                    id={2}

                                />

                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingTop: '1rem' }}>
                            <Grid xs={2} >
                                <Typography style={{ paddingTop: '1rem' }}>

                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <div className='d-flex justify-content-end'>
                                    <button className='btn btn-success' onClick={() => { handleAddEvent() }}>Add</button>
                                </div>
                            </Grid>
                        </Grid>
                        <table className='table'>
                            <thead className="thead-dark">
                                <tr>
                                    <th>
                                        Add on name
                                    </th>
                                    {/* <th>
                                        Min
                                    </th>
                                    <th>
                                        Max
                                    </th> */}
                                    <th>
                                        Quantity
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemNeedToBuy.map((data, index) => {
                                        return (
                                            <tr>

                                                <td>
                                                    {data.title}
                                                </td>

                                                <td>
                                                    <input type='number' className='form-control' placeholder='Quantity' />
                                                </td>
                                                <td>
                                                    <button className='btn btn-danger' onClick={() => { handleRemove(data.id) }}>Remove</button>
                                                </td>
                                            </tr>
                                        )

                                    })
                                }


                            </tbody>
                        </table>


                        {/* {
                            addons.length > 0 ? (
                                addons.map((name, index) => {
                                    return (
                                        <Grid container key={index}>
                                            <Grid item xs={2}>
                                                <Typography style={{ paddingTop: '1rem' }}>
                                                    {name.title} Quantity
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                                <div className='d-flex'>
                                                    <button className={`circleDiv ${quantity === 0 ? "disableMinus" : ""}`} onClick={() => { setquantity(parseInt(quantity) - 1) }}>-</button>
                                                    <input type="number" pattern="[0-9]*" className='form-control quantityNumber' value={quantity} onChange={event => { setquantity(event.target.value) }} />
                                                    
                                                    <button className='circleDiv' onClick={() => { setquantity(parseInt(quantity) + 1) }}>+</button>
                                                </div>

                                            </Grid>
                                        </Grid>

                                    )


                                })
                            )
                                : ""

                        } */}
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item Quantity
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <div className='d-flex'>
                                    <button className={`circleDiv ${quantity === 0 ? "disableMinus" : ""}`} onClick={() => { setquantity(parseInt(quantity) - 1) }}>-</button>
                                    <input type="number" pattern="[0-9]*" className='form-control quantityNumber' value={quantity} onChange={event => { setquantity(event.target.value) }} />
                                    {/* <button className='circleDiv'>{quantity}</button> */}
                                    <button className='circleDiv' onClick={() => { setquantity(parseInt(quantity) + 1) }}>+</button>
                                </div>

                            </Grid>
                        </Grid>

                        {/* <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Portion size
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={' Portion size'} value={textFieldValue} />

                            </Grid>
                        </Grid> */}
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddItemDialogComponent open={openItemDialog} onHandleAddItem={handleAddItem} />
        </div>
    );
}

export default AddSubscriptionItemDialog;